import React from "react";
import { Col, Container, Row, Table } from "react-bootstrap";
import Header from "../../stories/components/Header.js";
import LogoTableRow from "../../stories/components/LogoTableRow";
import LogoTableHead from "../../stories/components/LogoTableHead";

import {
  LogoInnlandetPrimaerBokmaalNegativPdf,
  LogoInnlandetPrimaerBokmaalNegativPng,
  LogoInnlandetPrimaerBokmaalNegativSvg,
  LogoInnlandetPrimaerBokmaalPositivPdf,
  LogoInnlandetPrimaerBokmaalPositivPng,
  LogoInnlandetPrimaerBokmaalPositivSvg,
  LogoInnlandetPrimaerBokmaalEngelskNegativPdf,
  LogoInnlandetPrimaerBokmaalEngelskNegativPng,
  LogoInnlandetPrimaerBokmaalEngelskNegativSvg,
  LogoInnlandetPrimaerBokmaalEngelskPositivPdf,
  LogoInnlandetPrimaerBokmaalEngelskPositivPng,
  LogoInnlandetPrimaerBokmaalEngelskPositivSvg,
  LogoInnlandetPrimaerNynorskNegativPdf,
  LogoInnlandetPrimaerNynorskNegativPng,
  LogoInnlandetPrimaerNynorskNegativSvg,
  LogoInnlandetPrimaerNynorskPositivPdf,
  LogoInnlandetPrimaerNynorskPositivPng,
  LogoInnlandetPrimaerNynorskPositivSvg,
  LogoInnlandetPrimaerNynorskEngelskNegativPdf,
  LogoInnlandetPrimaerNynorskEngelskNegativPng,
  LogoInnlandetPrimaerNynorskEngelskNegativSvg,
  LogoInnlandetPrimaerNynorskEngelskPositivPdf,
  LogoInnlandetPrimaerNynorskEngelskPositivPng,
  LogoInnlandetPrimaerNynorskEngelskPositivSvg,
  LogoInnlandetSekundaerBokmaalNegativPdf,
  LogoInnlandetSekundaerBokmaalNegativPng,
  LogoInnlandetSekundaerBokmaalNegativSvg,
  LogoInnlandetSekundaerBokmaalPositivPdf,
  LogoInnlandetSekundaerBokmaalPositivPng,
  LogoInnlandetSekundaerBokmaalPositivSvg,
  LogoInnlandetSekundaerBokmaalEngelskNegativPdf,
  LogoInnlandetSekundaerBokmaalEngelskNegativPng,
  LogoInnlandetSekundaerBokmaalEngelskNegativSvg,
  LogoInnlandetSekundaerBokmaalEngelskPositivPdf,
  LogoInnlandetSekundaerBokmaalEngelskPositivPng,
  LogoInnlandetSekundaerBokmaalEngelskPositivSvg,
  LogoInnlandetSekundaerNynorskNegativPdf,
  LogoInnlandetSekundaerNynorskNegativPng,
  LogoInnlandetSekundaerNynorskNegativSvg,
  LogoInnlandetSekundaerNynorskPositivPdf,
  LogoInnlandetSekundaerNynorskPositivPng,
  LogoInnlandetSekundaerNynorskPositivSvg,
  LogoInnlandetSekundaerNynorskEngelskNegativPdf,
  LogoInnlandetSekundaerNynorskEngelskNegativPng,
  LogoInnlandetSekundaerNynorskEngelskNegativSvg,
  LogoInnlandetSekundaerNynorskEngelskPositivPdf,
  LogoInnlandetSekundaerNynorskEngelskPositivPng,
  LogoInnlandetSekundaerNynorskEngelskPositivSvg,
  LogoInnlandetSentrertBokmaalNegativPdf,
  LogoInnlandetSentrertBokmaalNegativPng,
  LogoInnlandetSentrertBokmaalNegativSvg,
  LogoInnlandetSentrertBokmaalPositivPdf,
  LogoInnlandetSentrertBokmaalPositivPng,
  LogoInnlandetSentrertBokmaalPositivSvg,
  LogoInnlandetSentrertBokmaalEngelskNegativPdf,
  LogoInnlandetSentrertBokmaalEngelskNegativPng,
  LogoInnlandetSentrertBokmaalEngelskNegativSvg,
  LogoInnlandetSentrertBokmaalEngelskPositivPdf,
  LogoInnlandetSentrertBokmaalEngelskPositivPng,
  LogoInnlandetSentrertBokmaalEngelskPositivSvg,
  LogoInnlandetSentrertNynorskNegativPdf,
  LogoInnlandetSentrertNynorskNegativPng,
  LogoInnlandetSentrertNynorskNegativSvg,
  LogoInnlandetSentrertNynorskPositivPdf,
  LogoInnlandetSentrertNynorskPositivPng,
  LogoInnlandetSentrertNynorskPositivSvg,
  LogoInnlandetSentrertNynorskEngelskNegativPdf,
  LogoInnlandetSentrertNynorskEngelskNegativPng,
  LogoInnlandetSentrertNynorskEngelskNegativSvg,
  LogoInnlandetSentrertNynorskEngelskPositivPdf,
  LogoInnlandetSentrertNynorskEngelskPositivPng,
  LogoInnlandetSentrertNynorskEngelskPositivSvg,
} from "../../assets/logo/Innlandet/exportInnlandet.js";

export default function InnlandetPage() {
  return (
    <Container className="mb-6">
      <article>
        <Header
          title="Logofiler for Statsforvalteren i Innlandet"
          lead="Alle logoer for Innlandet i ulike variasjoner og filformater"
          breadcrumbText="Tilbake til logo"
          breadcrumbUrl="/logo"
        />
        <main>
          <Row>
            <Col md={{ span: 8, offset: 2 }}>
              <p>Tekst om logovarianter og filformater...</p>
            </Col>
          </Row>
          <Row className="my-6">
            <Col>
              <h4>Primærlogo</h4>
              <Table responsive size="lg" className="table-simple">
                <LogoTableHead />
                <tbody>
                <LogoTableRow
                    logoUrl={LogoInnlandetPrimaerBokmaalPositivSvg}
                    title="Primærlogo: Statsforvalteren i Innlandet, bokmål"
                    text="Bokmål"
                    blackSvg={LogoInnlandetPrimaerBokmaalPositivSvg}
                    blackPng={LogoInnlandetPrimaerBokmaalPositivPng}
                    blackPdf={LogoInnlandetPrimaerBokmaalPositivPdf}
                    whiteSvg={LogoInnlandetPrimaerBokmaalNegativSvg}
                    whitePng={LogoInnlandetPrimaerBokmaalNegativPng}
                    whitePdf={LogoInnlandetPrimaerBokmaalNegativPdf}
                  />
                  <LogoTableRow
                    logoUrl={LogoInnlandetPrimaerBokmaalEngelskPositivSvg}
                    title="Primærlogo: Statsforvalteren i Innlandet, bokmål + engelsk"
                    text="Bokmål + engelsk"
                    blackSvg={LogoInnlandetPrimaerBokmaalEngelskPositivSvg}
                    blackPng={LogoInnlandetPrimaerBokmaalEngelskPositivPng}
                    blackPdf={LogoInnlandetPrimaerBokmaalEngelskPositivPdf}
                    whiteSvg={LogoInnlandetPrimaerBokmaalEngelskNegativSvg}
                    whitePng={LogoInnlandetPrimaerBokmaalEngelskNegativPng}
                    whitePdf={LogoInnlandetPrimaerBokmaalEngelskNegativPdf}
                  />
                  <LogoTableRow
                    logoUrl={LogoInnlandetPrimaerNynorskPositivSvg}
                    title="Primærlogo: Statsforvalteren i Innlandet, nynorsk"
                    text="Nynorsk"
                    blackSvg={LogoInnlandetPrimaerNynorskPositivSvg}
                    blackPng={LogoInnlandetPrimaerNynorskPositivPng}
                    blackPdf={LogoInnlandetPrimaerNynorskPositivPdf}
                    whiteSvg={LogoInnlandetPrimaerNynorskNegativSvg}
                    whitePng={LogoInnlandetPrimaerNynorskNegativPng}
                    whitePdf={LogoInnlandetPrimaerNynorskNegativPdf}
                  />
                  <LogoTableRow
                    logoUrl={LogoInnlandetPrimaerNynorskEngelskPositivSvg}
                    title="Primærlogo: Statsforvalteren i Innlandet, nynorsk + engelsk"
                    text="Nynorsk + engelsk"
                    blackSvg={LogoInnlandetPrimaerNynorskEngelskPositivSvg}
                    blackPng={LogoInnlandetPrimaerNynorskEngelskPositivPng}
                    blackPdf={LogoInnlandetPrimaerNynorskEngelskPositivPdf}
                    whiteSvg={LogoInnlandetPrimaerNynorskEngelskNegativSvg}
                    whitePng={LogoInnlandetPrimaerNynorskEngelskNegativPng}
                    whitePdf={LogoInnlandetPrimaerNynorskEngelskNegativPdf}
                  />
                </tbody>
              </Table>
            </Col>
          </Row>
          <Row className="my-6">
            <Col>
              <h4>Sekundærlogo</h4>
              <Table responsive size="lg" className="table-simple">
                <LogoTableHead />
                <tbody>
                <LogoTableRow
                    logoUrl={LogoInnlandetSekundaerBokmaalPositivSvg}
                    title="Sekundærlogo: Statsforvalteren i Innlandet, bokmål"
                    text="Bokmål"
                    blackSvg={LogoInnlandetSekundaerBokmaalPositivSvg}
                    blackPng={LogoInnlandetSekundaerBokmaalPositivPng}
                    blackPdf={LogoInnlandetSekundaerBokmaalPositivPdf}
                    whiteSvg={LogoInnlandetSekundaerBokmaalNegativSvg}
                    whitePng={LogoInnlandetSekundaerBokmaalNegativPng}
                    whitePdf={LogoInnlandetSekundaerBokmaalNegativPdf}
                  />
                  <LogoTableRow
                    logoUrl={LogoInnlandetSekundaerBokmaalEngelskPositivSvg}
                    title="Sekundærlogo: Statsforvalteren i Innlandet, bokmål + engelsk"
                    text="Bokmål + engelsk"
                    blackSvg={LogoInnlandetSekundaerBokmaalEngelskPositivSvg}
                    blackPng={LogoInnlandetSekundaerBokmaalEngelskPositivPng}
                    blackPdf={LogoInnlandetSekundaerBokmaalEngelskPositivPdf}
                    whiteSvg={LogoInnlandetSekundaerBokmaalEngelskNegativSvg}
                    whitePng={LogoInnlandetSekundaerBokmaalEngelskNegativPng}
                    whitePdf={LogoInnlandetSekundaerBokmaalEngelskNegativPdf}
                  />
                  <LogoTableRow
                    logoUrl={LogoInnlandetSekundaerNynorskPositivSvg}
                    title="Sekundærlogo: Statsforvalteren i Innlandet, nynorsk"
                    text="Nynorsk"
                    blackSvg={LogoInnlandetSekundaerNynorskPositivSvg}
                    blackPng={LogoInnlandetSekundaerNynorskPositivPng}
                    blackPdf={LogoInnlandetSekundaerNynorskPositivPdf}
                    whiteSvg={LogoInnlandetSekundaerNynorskNegativSvg}
                    whitePng={LogoInnlandetSekundaerNynorskNegativPng}
                    whitePdf={LogoInnlandetSekundaerNynorskNegativPdf}
                  />
                  <LogoTableRow
                    logoUrl={LogoInnlandetSekundaerNynorskEngelskPositivSvg}
                    title="Sekundærlogo: Statsforvalteren i Innlandet, nynorsk + engelsk"
                    text="Nynorsk + engelsk"
                    blackSvg={LogoInnlandetSekundaerNynorskEngelskPositivSvg}
                    blackPng={LogoInnlandetSekundaerNynorskEngelskPositivPng}
                    blackPdf={LogoInnlandetSekundaerNynorskEngelskPositivPdf}
                    whiteSvg={LogoInnlandetSekundaerNynorskEngelskNegativSvg}
                    whitePng={LogoInnlandetSekundaerNynorskEngelskNegativPng}
                    whitePdf={LogoInnlandetSekundaerNynorskEngelskNegativPdf}
                  />
                </tbody>
              </Table>
            </Col>
          </Row>
          <Row className="my-6">
            <Col>
              <h4>Sentert logo</h4>
              <Table responsive size="lg" className="table-simple">
                <LogoTableHead />
                <tbody>
                <LogoTableRow
                    logoUrl={LogoInnlandetSentrertBokmaalPositivSvg}
                    title="Sentert logo: Statsforvalteren i Innlandet, bokmål"
                    text="Bokmål"
                    blackSvg={LogoInnlandetSentrertBokmaalPositivSvg}
                    blackPng={LogoInnlandetSentrertBokmaalPositivPng}
                    blackPdf={LogoInnlandetSentrertBokmaalPositivPdf}
                    whiteSvg={LogoInnlandetSentrertBokmaalNegativSvg}
                    whitePng={LogoInnlandetSentrertBokmaalNegativPng}
                    whitePdf={LogoInnlandetSentrertBokmaalNegativPdf}
                  />
                  <LogoTableRow
                    logoUrl={LogoInnlandetSentrertBokmaalEngelskPositivSvg}
                    title="Sentert logo: Statsforvalteren i Innlandet, bokmål + engelsk"
                    text="Bokmål + engelsk"
                    blackSvg={LogoInnlandetSentrertBokmaalEngelskPositivSvg}
                    blackPng={LogoInnlandetSentrertBokmaalEngelskPositivPng}
                    blackPdf={LogoInnlandetSentrertBokmaalEngelskPositivPdf}
                    whiteSvg={LogoInnlandetSentrertBokmaalEngelskNegativSvg}
                    whitePng={LogoInnlandetSentrertBokmaalEngelskNegativPng}
                    whitePdf={LogoInnlandetSentrertBokmaalEngelskNegativPdf}
                  />
                  <LogoTableRow
                    logoUrl={LogoInnlandetSentrertNynorskPositivSvg}
                    title="Sentert logo: Statsforvalteren i Innlandet, nynorsk"
                    text="Nynorsk"
                    blackSvg={LogoInnlandetSentrertNynorskPositivSvg}
                    blackPng={LogoInnlandetSentrertNynorskPositivPng}
                    blackPdf={LogoInnlandetSentrertNynorskPositivPdf}
                    whiteSvg={LogoInnlandetSentrertNynorskNegativSvg}
                    whitePng={LogoInnlandetSentrertNynorskNegativPng}
                    whitePdf={LogoInnlandetSentrertNynorskNegativPdf}
                  />
                  <LogoTableRow
                    logoUrl={LogoInnlandetSentrertNynorskEngelskPositivSvg}
                    title="Sentert logo: Statsforvalteren i Innlandet, nynorsk + engelsk"
                    text="Nynorsk + engelsk"
                    blackSvg={LogoInnlandetSentrertNynorskEngelskPositivSvg}
                    blackPng={LogoInnlandetSentrertNynorskEngelskPositivPng}
                    blackPdf={LogoInnlandetSentrertNynorskEngelskPositivPdf}
                    whiteSvg={LogoInnlandetSentrertNynorskEngelskNegativSvg}
                    whitePng={LogoInnlandetSentrertNynorskEngelskNegativPng}
                    whitePdf={LogoInnlandetSentrertNynorskEngelskNegativPdf}
                  />
                </tbody>
              </Table>
            </Col>
          </Row>
        </main>
      </article>
    </Container>
  );
}
